import { type MouseEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Explicit parent paths for the Return link. Going "back" means going up one
 * level in this hierarchy, regardless of how the user actually got there
 * (direct URL, deep link, internal navigation). This is more predictable than
 * `history.back()`, which can land the user somewhere unexpected.
 */
const PARENT_PATH: Record<string, string> = {
  '/arena/watch': '/arena',
  '/arena/watch/debate': '/arena/watch',
  '/arena/spar': '/arena',
  '/arena': '/',
  '/worldview': '/',
};

/** Prefix-based parent resolution for dynamic segments (e.g. /worldview/chat/:id). */
const PARENT_PREFIX: Array<[prefix: string, parent: string]> = [
  ['/worldview/chat/', '/worldview'],
  ['/arena/spar/', '/arena/spar'],
];

export function SceneBack() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const exactMatch = PARENT_PATH[location.pathname];
    if (exactMatch !== undefined) {
      navigate(exactMatch);
      return;
    }
    const prefixMatch = PARENT_PREFIX.find(([prefix]) =>
      location.pathname.startsWith(prefix),
    );
    navigate(prefixMatch ? prefixMatch[1] : '/');
  };

  return (
    <button
      type="button"
      className="scene__back"
      aria-label="Return"
      onClick={handleClick}
    >
      <span className="scene__back-arrow" aria-hidden="true">
        ←
      </span>
      <span className="scene__back-label">Return</span>
    </button>
  );
}
